// Task due-date helpers, mirroring Android's TimeDateUtil.convertMillisToDate:
// dueDate is epoch millis (a non-null Long on the wire, 0 = "no due date"),
// stored as UTC midnight of the chosen day by the Android date picker, and
// always FORMATTED IN UTC so the same value renders as the same day on every
// device regardless of timezone.

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/** "MMM dd, yyyy" in UTC (Android's default date format), or "No Date" for 0. */
export const formatDueDate = (ms) => {
  if (!ms || ms <= 0) return "No Date";
  const d = new Date(Number(ms));
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${MONTHS[d.getUTCMonth()]} ${day}, ${d.getUTCFullYear()}`;
};

/** Millis -> "YYYY-MM-DD" (UTC) for <input type="date">; "" when unset. */
export const dueDateToInput = (ms) => {
  if (!ms || ms <= 0) return "";
  const d = new Date(Number(ms));
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${d.getUTCFullYear()}-${m}-${day}`;
};

/**
 * "YYYY-MM-DD" -> UTC-midnight millis (what Android's Material3 picker stores
 * via selectedDateMillis). Empty/invalid input -> 0, the "no due date"
 * sentinel — never null (Android's TaskData.dueDate is a non-null Long).
 */
export const inputToDueDate = (value) => {
  if (!value) return 0;
  const [y, m, d] = value.split("-").map(Number);
  if (!y || !m || !d) return 0;
  return Date.UTC(y, m - 1, d);
};
